import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
} from "@mui/material";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import dayjs from "dayjs";
import Header from "../panel/Header";

const db = getFirestore();

function Allexpensereport() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    if (!fromDate || !toDate) {
      alert("Please select both dates");
      return;
    }
    setLoading(true);

    const start = new Date(fromDate);
    const end = new Date(toDate);
    end.setHours(23, 59, 59, 999);

    let data = [];

    try {
      // --- Purchases ---
      const q1 = query(
        collection(db, "purchases"),
        where("created", ">=", start),
        where("created", "<=", end)
      );
      const snap1 = await getDocs(q1);
      snap1.forEach((doc) => {
        const d = doc.data();
        data.push({
          id: doc.id,
          date: d.created?.toDate(),
          section: d.category || "Purchase",
          amount: d.grandTotal || 0,
          type: d.paytype || "Cash",
          source: "Purchase",
        });
      });

      // --- Loans ---
      // const q2 = query(
      //   collection(db, "loans"),
      //   where("loandate", ">=", start),
      //   where("loandate", "<=", end)
      // );
      // const snap2 = await getDocs(q2);
      // snap2.forEach((doc) => {
      //   const d = doc.data();
      //   data.push({
      //     id: doc.id,
      //     date: d.loandate?.toDate(),
      //     section: "Loan",
      //     amount: d.loanamount || 0,
      //     type: "Loan Issued",
      //     source: "Loan",
      //   });
      // });

      // --- Takkevari Loans ---
      // const q3 = query(
      //   collection(db, "takkevariloans"),
      //   where("createdAt", ">=", start),
      //   where("createdAt", "<=", end)
      // );
      // const snap3 = await getDocs(q3);
      // snap3.forEach((doc) => {
      //   const d = doc.data();
      //   data.push({
      //     id: doc.id,
      //     date: d.createdAt?.toDate(),
      //     section: "Takkevari Loan",
      //     amount: d.amount || 0,
      //     type: "Loan Issued",
      //     source: "Takkevari Loan",
      //   });
      // });

      // Sort by date
      data.sort((a, b) => new Date(a.date) - new Date(b.date));

      setReport(data);
    } catch (err) {
      console.error("Error fetching expense report:", err);
    }
    setLoading(false);
  };

  return (
    <Box p={3}>
      <Header />

      {/* Date Filters with Total */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" gap={2}>
          <TextField
            type="date"
            label="From Date"
            size="small"
            InputLabelProps={{ shrink: true }}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
          <TextField
            type="date"
            size="small"
            label="To Date"
            InputLabelProps={{ shrink: true }}
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
          <Button variant="contained" onClick={fetchReport} disabled={loading}>
            {loading ? "Loading..." : "Fetch"}
          </Button>
        </Box>

        <Typography variant="h6" fontWeight="bold" color="error">
          Total Expense: ₹ {report.reduce((sum, r) => sum + (r.amount || 0), 0)}
        </Typography>
      </Box>

      {/* Report Table */}
      <Paper elevation={3}>
        <TableContainer sx={{ maxHeight: 500 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell><b>Date</b></TableCell>
                <TableCell><b>Source</b></TableCell>
                <TableCell><b>Section</b></TableCell>
                <TableCell align="right"><b>Amount</b></TableCell>
                <TableCell><b>Type</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {report.map((row, index) => (
                <TableRow
                  key={row.id}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#fafafa" : "white",
                    "&:hover": { backgroundColor: "#ffebee" },
                  }}
                >
                  <TableCell>{dayjs(row.date).format("DD/MM/YYYY")}</TableCell>
                  <TableCell>{row.source}</TableCell>
                  <TableCell sx={{ textTransform: "capitalize" }}>{row.section}</TableCell>
                  <TableCell align="right">₹ {row.amount}</TableCell>
                  <TableCell>{row.type}</TableCell>
                </TableRow>
              ))}
              {report.length === 0 && !loading && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No data found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}

export default Allexpensereport;
